var _defs, _path, _path2, _g, _path3, _circle, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicios2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feecb0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.53,152.52H27.2c-4.82,0-8.74-3.92-8.74-8.74v-61.76c0-4.82,3.92-8.74,8.74-8.74H119.53c4.82,0,8.74,3.92,8.74,8.74v61.76c0,4.82-3.92,8.74-8.74,8.74ZM27.2,78.28c-2.06,0-3.74,1.68-3.74,3.74v61.76c0,2.06,1.68,3.74,3.74,3.74H119.53c2.06,0,3.74-1.68,3.74-3.74v-61.76c0-2.06-1.68-3.74-3.74-3.74H27.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.13,134.83H34.6c-3.66,0-6.64-2.98-6.64-6.64v-40.29c0-3.66,2.98-6.64,6.64-6.64H112.13c3.66,0,6.64,2.98,6.64,6.64v40.29c0,3.66-2.98,6.64-6.64,6.64ZM34.6,85.26c-1.46,0-2.64,1.18-2.64,2.64v40.29c0,1.46,1.19,2.64,2.64,2.64H112.13c1.46,0,2.64-1.18,2.64-2.64v-40.29c0-1.46-1.18-2.64-2.64-2.64H34.6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.14,167.24l-3.79-3.26c1.23-1.44,2.28-3.02,3.12-4.7,1.44-2.9,2.24-6.05,2.38-9.36l5,.21c-.17,4.02-1.14,7.84-2.9,11.38-1.02,2.05-2.3,3.98-3.8,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.58,167.24c-1.5-1.75-2.78-3.68-3.8-5.73-1.75-3.53-2.73-7.36-2.9-11.38l5-.21c.14,3.31,.94,6.46,2.38,9.36,.84,1.68,1.88,3.26,3.12,4.7l-3.79,3.26Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.81,168.11H54.92c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h36.89c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 73.36,
    cy: 141.43,
    r: 3.84
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.23,168.1h-49.57c-5.7,0-10.33-4.63-10.33-10.32v-7.76c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v7.76c0,2.93,2.39,5.32,5.33,5.32h49.57c2.93,0,5.32-2.39,5.32-5.32V42.21c0-2.93-2.39-5.32-5.32-5.32h-49.57c-2.94,0-5.33,2.39-5.33,5.32v33.56c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5V42.21c0-5.69,4.63-10.32,10.33-10.32h49.57c5.69,0,10.32,4.63,10.32,10.32v115.57c0,5.69-4.63,10.32-10.32,10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.57,57.77h-36.26c-3.61,0-6.55-2.94-6.55-6.55v-2.87c0-3.61,2.94-6.55,6.55-6.55h36.26c3.61,0,6.55,2.94,6.55,6.55v2.87c0,3.61-2.94,6.55-6.55,6.55Zm-36.26-11.48c-1.13,0-2.05,.92-2.05,2.05v2.87c0,1.13,.92,2.05,2.05,2.05h36.26c1.13,0,2.05-.92,2.05-2.05v-2.87c0-1.13-.92-2.05-2.05-2.05h-36.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.44,158.47c-5.12,0-9.29-4.17-9.29-9.29s4.17-9.29,9.29-9.29,9.29,4.17,9.29,9.29-4.17,9.29-9.29,9.29Zm0-14.09c-2.64,0-4.79,2.15-4.79,4.79s2.15,4.79,4.79,4.79,4.79-2.15,4.79-4.79-2.15-4.79-4.79-4.79Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios2);
export default __webpack_public_path__ + "static/media/servicios2.66456b657fd6b49baf4883cf8dcc5fbc.svg";
export { ForwardRef as ReactComponent };